export const FETCHING_RESOURCES = 'FETCHING_RESOURCES';
export const FETCHING_RESOURCES_SUCCESS = 'FETCHING_RESOURCES_SUCCESS';
export const FETCHING_RESOURCES_FAILED = 'FETCHING_RESOURCES_FAILED';

export const ADD_RESOURCE = 'ADD_RESOURCE';
export const ADD_RESOURCE_FAILED = 'ADD_RESOURCE_FAILED';
export const ADD_RESOURCE_SUCCESS = 'ADD_RESOURCE_SUCCESS';

export const DELETE_RESOURCE = 'DELETE_RESOURCES';
export const DELETE_RESOURCES_SUCCESS = 'DELETE_RESOURCES_SUCCESS';
export const DELETE_RESOURCES_FAILED = 'DELETE_RESOURCES_FAILED';

export const FETCH_SINGLE_DOCUMENT = 'FETCH_SINGLE_DOCUMENT';
export const FETCH_SINGLE_DOCUMENT_FAILED = 'FETCH_SINGLE_DOCUMENT_FAILED';
export const FETCH_SINGLE_DOCUMENT_SUCCESS = 'FETCH_SINGLE_DOCUMENT_SUCCESS';
